import { debounce } from 'lodash'
import { TABLE_MODE } from './config'

function getElUsableHeight(el, getElUsableHeight) {
  if (!el) {
    return {
      height: 0,
      width: 0
    }
  }
  const contentRect = el.getBoundingClientRect()
  const dis = contentRect.top + getElUsableHeight
  const height = window.innerHeight - dis
  return {
    height,
    width: contentRect.width
  }
}

function createDebounceEvent(fn) {
  return debounce(fn, 5)
}

export function createTableContainer() {
  return {
    name: 'TableContainer',
    props: {
      store: Object,
      width: [Number, String],
      height: [Number, String],
      border: Boolean,
      tableName: String,
      maxHeight: Number,
    },
    data() {
      return {
        observer: null,
        visibility: true
      }
    },
    watch: {
      maxHeight() {
        this.handleResize()
      },
      'store.states.hScrollbarShow': function (v) {
        const { width, height } = this.$props
        // 设置了宽高走
        if (width && height) {
          const { $props } = this.$parent
          const _height = v ? Math.min(height, height - $props.reserveHeight) : height
          this.changeSize({ width: width, height: _height })
        }
      }
    },
    mounted() {
      this.handleResize()
      this.observer = new ResizeObserver(this.handleVisibility)
      this.observer.observe(this.$parent.$el)
      this.throttleHandleResize = createDebounceEvent(this.handleResize)
      window.addEventListener('resize', this.throttleHandleResize)
    },
    beforeDestroy() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
      window.removeEventListener('resize', this.throttleHandleResize)
    },
    methods: {
      // throttleHandleResize: throttle(function () {
      //   this.handleResize()
      // }, 30),
      handleResize() {
        const { $el: parantEl, $props } = this.$parent
        let { width, height = 0 } = {}
        // 表格被隐藏。不应该被计算
        if (parantEl.offsetParent === null) {
          this.visibility = false
          return
        }
        const contentRect = getElUsableHeight(parantEl, $props.reserveHeight)
        height = contentRect.height
        width = contentRect.width
        const { paddingLeft, paddingRight, paddingTop, paddingBottom } = getComputedStyle(parantEl)
        const left = Number.parseInt(paddingLeft) || 0
        const right = Number.parseInt(paddingRight) || 0
        const top = Number.parseInt(paddingTop) || 0
        const bottom = Number.parseInt(paddingBottom) || 0
        const _width = width - left - right
        let _height = height - top - bottom
        // 这里的逻辑是不满足getElUsableHeight方法的兜底，场景是当这个表格在具体可视区域较底部的时候高度分配太低
        const headerTotalHeight = this.store.headerTotalHeight
        const footerTotalHeight = this.store.footerTotalHeight
        // 内容最低高度需排除固定高度（头部、尾部，固定行）
        const estimateTableBodyHeight = _height - headerTotalHeight - footerTotalHeight
        const rowHeight = ($props.rowHeight * 5)
        const rowTotalHeight = this.store.rowTotalHeight
        // 按内容高度适配
        if ($props.autoLowHeight && ((estimateTableBodyHeight < rowHeight) || ($props.mode === TABLE_MODE.CONTENT))) {
          _height = rowTotalHeight + headerTotalHeight + footerTotalHeight + $props.vScrollbarSize
        }
        this.changeSize({
          width: $props.width ? $props.width : _width,
          height: $props.height ? $props.height : _height
        })
      },
      handleVisibility() {
        const { $el: parentEl } = this.$parent
        const isVisible = parentEl.offsetParent !== null
        if (!isVisible) {
          this.visibility = false
        }
        if (this.visibility === false && isVisible) {
          this.visibility = true
          this.handleResize()
        }
      },
      changeSize({ width, height } = {}) {
        this.$emit('changeSize', { width, height })
      },
    },
    render() {
      const { width, columns = [] } = this.store.states
      const { tableHeight } = this.store
      const { border } = this.$props
      const _height = tableHeight
      let containerStyle = `width: ${width}px;`
      if (_height) containerStyle += `height: ${_height}px;`
      const tableContainerClass = [
        'kye-table-v2__container',
        border && tableHeight && columns.length ? 'kye-table-v2__boder' : '',
      ]
      return (
        <div class={tableContainerClass} style={containerStyle}>
          {this.$slots.default}
        </div>
      )
    }
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-table2/table-container.js